export default __webpack_public_path__ + "static/Bats-8471be7d9651895342bf14e311174a5a.jpeg";